/** Shared wire contract for observed Google ad-session context. No inferred values. */
export interface GoogleSessionDetails {
  gadSource: string;
  gadCampaignId: string;
  sessionStartTimeMicros: string;
  landingPageUserAgent: string;
}

export const GOOGLE_SESSION_MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;
export const GOOGLE_SESSION_COOKIE = "_tst_google_session";
export const GOOGLE_SESSION_USER_AGENT_LIMIT = 1024;
const FUTURE_TOLERANCE_MS = 5 * 60 * 1000;
const MICROSECONDS_PER_MS = 1000;

export function parseGoogleSession(value: unknown, nowMs: number = Date.now()): GoogleSessionDetails | undefined {
  if (!value || typeof value !== "object" || Array.isArray(value)) return undefined;
  const data = value as Record<string, unknown>;
  if (typeof data.gadSource !== "string" || !/^\d{1,12}$/.test(data.gadSource)) return undefined;
  if (typeof data.gadCampaignId !== "string" || !/^[1-9]\d{0,19}$/.test(data.gadCampaignId)) return undefined;
  if (typeof data.sessionStartTimeMicros !== "string" || !/^\d{13,18}$/.test(data.sessionStartTimeMicros)) return undefined;
  const micros = Number(data.sessionStartTimeMicros);
  if (!Number.isSafeInteger(micros)) return undefined;
  const age = nowMs - micros / MICROSECONDS_PER_MS;
  if (age < -FUTURE_TOLERANCE_MS || age > GOOGLE_SESSION_MAX_AGE_MS) return undefined;
  if (typeof data.landingPageUserAgent !== "string") return undefined;
  const ua = data.landingPageUserAgent.trim();
  if (!ua || ua.length > GOOGLE_SESSION_USER_AGENT_LIMIT || /[\u0000-\u001f]/.test(ua)) return undefined;
  return { gadSource: data.gadSource, gadCampaignId: data.gadCampaignId,
    sessionStartTimeMicros: data.sessionStartTimeMicros, landingPageUserAgent: ua };
}
